import RequestPageTwo from "./RequestPageTwo";

const BuildingFund = () => {
    return (
        <RequestPageTwo title="Bulding Fund Request"
            fetchUrl="/get-building-fund-requests"
            editEndpoint="update-building-fund-requests"
            deleteEndpoint="delete-building-fund-requests"
            statusEndpoint="update-building-fund-requests" />
    );
}

export default BuildingFund;
